
export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';

export const setCategoryData = arr => {
  return {
    type: SET_CATEGORY_DATA,
    payload: arr
  };
};
